'use client'

import { FC, useState } from 'react'
// import { useRouter, usePathname, useSearchParams } from 'next/navigation'

import { PaginatedPortfolioWorkListPublic, PortfolioTag } from '@/api'
import {
  PAGINATION_DEFAULT_PAGE,
  PAGINATION_DEFAULT_SIZE,
  GALLERY_SIZE,
} from '@/constants/pagination'
import { Container } from '@/uikit/container'
import { ButtonTab } from '@/uikit/button-tab'
import { ElementsPortfolio } from '@/components/elements-portfolio'
import { getPortfolioList } from '@/modules/portfolio'
import { Pagination } from '@/uikit/pagination'

import styles from './portfolio.module.scss'

interface PortfolioProps {
  portfolio: PaginatedPortfolioWorkListPublic
  tags: PortfolioTag[]
  header?: string | null
}

export const Portfolio: FC<PortfolioProps> = ({ portfolio, tags, header }) => {
  // const router = useRouter()
  // const pathname = usePathname()
  // const searchParams = useSearchParams()
  const [gallery, setGallery] = useState(portfolio)
  const [activeTag, setActiveTag] = useState(tags[0].id)
  const [currentPage, setCurrentPage] = useState(PAGINATION_DEFAULT_PAGE)

  // const updatePagination = (page: number, size: number) => {
  //   router.push(`${pathname}?page=${page}&size=${size}`, { scroll: true })
  // }

  const getPortfolioByTag = async (tagId: number) => {
    const page = PAGINATION_DEFAULT_PAGE
    const portfolio = await getPortfolioList({
      tagId,
      gallerySize: GALLERY_SIZE,
      page,
      size: PAGINATION_DEFAULT_SIZE,
    })
    setCurrentPage(page)
    setGallery(portfolio)
    setActiveTag(tagId)
    // updatePagination(page, PAGINATION_DEFAULT_SIZE)
  }

  const onPageChange = async (page: number) => {
    const portfolio = await getPortfolioList({
      tagId: activeTag,
      gallerySize: GALLERY_SIZE,
      page: page,
      size: PAGINATION_DEFAULT_SIZE,
    })
    setCurrentPage(page)
    setGallery(portfolio)
    // updatePagination(page, PAGINATION_DEFAULT_SIZE)
  }

  return (
    <Container>
      <div className={styles.root}>
        {header && <h1 className={styles.header}>{header}</h1>}
        <div className={styles.tabs_container}>
          <div className={styles.tabs}>
            {tags.map((tag) => (
              <ButtonTab
                key={tag.id}
                isActive={tag.id === activeTag}
                onClick={() => getPortfolioByTag(tag.id)}
              >
                {tag.name}
              </ButtonTab>
            ))}
          </div>
        </div>
        <ElementsPortfolio list={gallery.results} />
        <div className={styles.pagination}>
          <Pagination
            currentPage={currentPage}
            totalCount={gallery.count ?? 0}
            pageSize={PAGINATION_DEFAULT_SIZE}
            onPageChange={(page: number) => onPageChange(page)}
          />
        </div>
      </div>
    </Container>
  )
}
